import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const state = {
  status: [
    'waiting-for-contract-approval',
    'waiting-for-order-approval',
    'waiting-for-initial-survey',
    'waiting-for-sampling',
    'waiting-for-final-survey',
    'waiting-for-sample-to-be-received',
    'waiting-for-preparation',
    'waiting-for-testing',
    'waiting-for-job-approval',
    'waiting-for-report-approval',
    'waiting-for-payment',
    'waiting-for-payment-approval',
    'waiting-for-customer-feedback',
    'finished',
    'finish-reject',
  ],
};

export default new Vuex.Store({
  state,
});
